import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "header" }

import ModalOverlay from '@/design-system/molecules/ModalOverlay.vue'
import MarkDown from '@/components/MarkDown.vue'
import CardBase from './CardBase.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import TextBase from '@/design-system/atoms/TextBase.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoOverlay',
  props: {
    isVisible: { type: Boolean },
    title: {},
    info: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalOverlay, {
    "is-visible": _ctx.isVisible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(CardBase, { class: "info-container" }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TextBase, {
              text: _ctx.title ?? '',
              type: "h5"
            }, null, 8, ["text"]),
            _createVNode(ButtonText, {
              id: "info-overlay-exit",
              class: "close-button",
              iconLeft: require('@/design-system/assets/icons/Icon-X-Small.svg'),
              size: "extra-small",
              onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, null, 8, ["iconLeft"])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.info)
            ? (_openBlock(), _createBlock(MarkDown, {
                key: 0,
                source: _ctx.info
              }, null, 8, ["source"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})